import { Injectable } from '@angular/core';
import { SessionService } from '../../shared/session-service/session.service';
import { API_URL } from '../../shared/constants/apiurl-constants';
import { role } from 'src/app/shared/constants/role-enum';
import { tap } from 'rxjs/operators';
import { UserDetails } from '../models/user-details.model';
import { LoggedInUserService } from '../../shared/logged-in-user/logged-in-user.service';
import { getInitials } from '../../shared/lib/get-intitials';
import { catchError } from 'rxjs/operators';
import { ToastrService } from '@kpmg-tax/ui';
import { APP_ERROR_CONSTANTS } from 'src/app/shared/constants/app-constants';
import { of } from 'rxjs';

@Injectable()
// provides http methods related to Auth
export class AuthorizationService {

    constructor(
        private sessionService: SessionService,
        private loggedInUserService: LoggedInUserService,
        private _toastr: ToastrService,
    ) { }

    setValuesOnInitializePermissionCall(): void{
        this.sessionService.apiUrlGet(API_URL.GETPERMISSIONS).pipe(
            tap((data: IGetPermissionsResponse) => {
                const userDetails: UserDetails = {
                    userId: data.result.currentUserId,
                    firstName: data.result.firstName,
                    lastName: data.result.lastName,
                    userNameInitials: getInitials(data.result.firstName, data.result.lastName),
                    email: data.result.email,
                    roleId: data.result.roleId,
                    permissions: data.result.permissions,
                };
                this.loggedInUserService.setUserDetails(userDetails);               
            }),            
        ).subscribe()
    }
}


export interface IGetPermissionsResponse {
    result: {
        permissions: string[];
        clientId: number;
        clientName: string;
        roleId: role;
        roleIds: role[];
        currentUserId: number;
        firstName: string;
        lastName: string;
        displayName: string;
        signInName: string;
        email: string;
    }
}
